import * as React from "react";
import { gql, useMutation, ApolloError, MutationTuple } from "@apollo/client";
import {
  UpdateIndustryMutationMutation,
  UpdateIndustryMutationMutationVariables
} from "../../../../schemaTypes";

export const updateIndustryMutation = gql`
mutation UpdateIndustryMutation(
    $industryId: String!,
    $input: UpdateIndustryInput!
) {
    updateIndustry(
        industryId: $industryId,
        input: $input
    ) {
        errors {
            path
            message
        }
        message
    }
  }
`;

interface Props {
    children: (data: {
        updateIndustry: MutationTuple<
            UpdateIndustryMutationMutation,
            UpdateIndustryMutationMutationVariables
        >[0];
        loading: boolean;
        error?: ApolloError;
        data?: UpdateIndustryMutationMutation;
        errors?: { path: string; message: string }[] | null;
        message?: string | null;
    }) => React.ReactElement | null;
}

export const UpdateIndustry: React.FC<Props> = ({ children }) => {
    const [updateIndustry, { loading, error, data }] = useMutation<UpdateIndustryMutationMutation, UpdateIndustryMutationMutationVariables>(updateIndustryMutation);

    const errorsRaw = data?.updateIndustry?.errors ?? null;
    const errors = Array.isArray(errorsRaw)
        ? errorsRaw.filter((e): e is { path: string; message: string } => !!e)
        : errorsRaw;
    const message = data?.updateIndustry?.message ?? null;

    return children({
        updateIndustry,
        loading,
        error,
        data: data ?? undefined,
        errors,
        message
    });
};
